export const tokenAddresses = {
  EUL: "0xEb9b5f4EB023aE754fF59A04c9C038D58606DAC6",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0x56C44d2F484A61ce92Fa0BCc849feB37aBfeB59C",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
